import { render } from "./addAdsPanner.vue?vue&type=template&id=3d1125f0"
import script from "./addAdsPanner.vue?vue&type=script&lang=js"
export * from "./addAdsPanner.vue?vue&type=script&lang=js"

import "./addAdsPanner.vue?vue&type=style&index=0&id=3d1125f0&lang=css"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__